module.exports = __webpack_public_path__ + "img/works_img20022502.b9b78778.jpg";